import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatMomentDateModule} from '@angular/material-moment-adapter';
import {FlexLayoutModule} from '@angular/flex-layout';
import {LayoutModule} from '@angular/cdk/layout';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {InvoiceProcessingRoutingModule} from './invoice-processing-routing.module';
import {
    CommentActionComponent,
    InvoiceProcessingComponent,
    PurchaseOrderSnackBarComponent,
    SearchSupplierComponent,
} from './invoice-processing.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {TranslateModule} from '@ngx-translate/core';
import {ExpenseCodingFieldComponent} from './components/expense-coding-field/expense-coding-field.component';
import {
    ClearPaidMarkerModalComponent,
    MarkAsPaidModalComponent,
    MarkPaidSnackBarComponent
} from '../invoice-explorer/invoice-explorer.component';
import {ChipListEmailInputComponent} from '../invoice-explorer/markaspaid/chip-list-email/chip-list-email-input.component';

@NgModule({
    declarations: [
        InvoiceProcessingComponent,
        CommentActionComponent,
        SearchSupplierComponent,
        // TODO: should move to invoiceProcessing module ts file
        MarkAsPaidModalComponent,
        ClearPaidMarkerModalComponent,
        MarkPaidSnackBarComponent,
        PurchaseOrderSnackBarComponent,
        ExpenseCodingFieldComponent,
        ChipListEmailInputComponent
    ],
    imports: [
        CommonModule,
        InvoiceProcessingRoutingModule,
        FormsModule,
        ReactiveFormsModule,
        FlexLayoutModule,
        LayoutModule,
        PdfViewerModule,
        /* Angular material */
        MatDatepickerModule,
        MatNativeDateModule,
        MatMomentDateModule,
        MatButtonModule,
        MatIconModule,
        MatGridListModule,
        MatCardModule,
        MatInputModule,
        MatSelectModule,
        MatRadioModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatProgressBarModule,
        MatTooltipModule,
        MatSidenavModule,
        MatListModule,
        MatSnackBarModule,
        MatDialogModule,
        MatBadgeModule,
        NgxMatSelectSearchModule,
        TranslateModule,
        MatCheckboxModule,
        MatAutocompleteModule,
    ],
    exports: [InvoiceProcessingComponent],
})
export class InvoiceProcessingModule {
}
